<template>
  <div class="mb-3">
    <button class="p-button p-component p-button-info mr-2" @click="this.$router.push('/solicitud-insumos')">Solic. Insumos</button>
    <button class="p-button p-component p-button-success mr-2" @click="this.$router.push('/solicitud-insumos')">Nuevo</button>    
  </div>

  <Dialog header="Atención!" v-model:visible="showPauseReportModal" :style="{width: '50vw'}">
      <div  class="grid operator-alert" >
          <div class="col-12 operator-alert">
              <h1>Hay PPP pausadas por un Supervisor</h1>
          </div>
      </div>
  </Dialog>

  <div>
    <div class="grid">
      <div class="col-3" >
      <div class="card" :class="{ 'card-active': show==1 }" style="border-bottom: 5px solid #1C95C2" @click="setTab('1')">
        <div class="grid">
          <div class="col-10">
            <h1>{{ process_orders.length }}</h1>            
          </div>
          <div class="col-2">
            <div class="notifications" v-if="not_seem_1">{{not_seem_1}}</div>            
          </div>
        </div>
        <h3>EN PROCESO</h3>
      </div>
    </div>
    <div class="col-3" >
      <div class="card" :class="{ 'card-active': show==0 }" style="border-bottom: 5px solid #9A9A9A" @click="setTab('0')">
        <div class="grid">
          <div class="col-10">
              <h1>{{ no_init_orders.length }}</h1>            
            </div>
            <div class="col-2">
              <div class="notifications" v-if="not_seem_2">{{not_seem_2}}</div>
            </div>          
        </div>
        <h3>SIN INICIAR</h3>
      </div>
    </div>
    <div class="col-3" >
      <div class="card" :class="{ 'card-active': show==2 }" style="border-bottom: 5px solid #EEC216" @click="setTab('2')">        
        <div class="grid">
          <div class="col-10">
              <h1>{{ paused_orders.length }}</h1>              
            </div>
            <div class="col-2">
              <div class="notifications" v-if="not_seem_3">{{not_seem_3}}</div>            
            </div>          
        </div>
        <h3>EN PAUSA</h3>  
      </div>
    </div>
    <div class="col-3" >
      <div class="card" :class="{ 'card-active': show==3 }" style="border-bottom: 5px solid #7E57C2" @click="setTab('3')">
        <div class="grid">
          <div class="col-10">
              <h1>{{ quality_orders.length }}</h1>
            </div>
            <div class="col-2">
              <div class="notifications" v-if="not_seem_4">{{not_seem_4}}</div>            
            </div>          
        </div>
        <h3>EN CALIDAD</h3>  
      </div>
    </div>

  </div>

  <div class="cards">
    <div class="grid"> 
      <OtiForOp v-if="show==1" :status="1" v-for="order in process_orders" :key="order.id" :order="order" /> 
      <OtiForOp v-if="show==0" :status="0" v-for="order in no_init_orders" :key="order.id" :order="order" /> 
      <OtiForOp v-if="show==2" :status="2" v-for="order in paused_orders" :key="order.id" :order="order" /> 
      <OtiForOp v-if="show==3" :status="3" v-for="order in quality_orders" :key="order.id" :order="order" /> 
    </div>
  </div>
  <!--
    <TabView ref="tabview1">
      <TabPanel header="EN PROCESO">
          <div class="grid"> <OtiForOp v-for="order in orders.filter((order) => order.status == 1)" :key="order.id" :order="order" /> </div>
      </TabPanel>
      <TabPanel header="SIN INICIAR">
          <div class="grid"> <OtiForOp v-for="order in orders.filter((order) => order.status == 0)" :key="order.id" :order="order" /> </div>
      </TabPanel>

      <TabPanel header="EN PAUSA">
          <div class="grid"> <OtiForOp v-for="order in orders.filter((order) => order.status == 2)" :key="order.id" :order="order" /> </div>
      </TabPanel>
      <TabPanel header="EN CALIDAD">
          <div class="grid"> <OtiForOp v-for="order in orders.filter((order) => order.status == 3)" :key="order.id" :order="order" /> </div>
      </TabPanel>
                  
    </TabView>
    -->

<!-- 
     
- <div class="">
    TABLA DE CONTROL
</div>

        <div class="mt-3">
          <div class="col-12">
            <OtiClock
              :order="order"
              :opGroup="opGroup"
            />
          </div>
        </div>
				<p>{{ order }}</p> 
      </div> -->
    <!-- </div> -->
  </div>
</template>

<script>
import OtiClock from "./../OtiClock.vue";
import CrudService from "./../../services/crud.service.js" 
import OtiForOp from "./OtiForOp.vue";

export default {
  props: ['opId', 'opGroup'],
  components: {
    OtiClock,
    OtiForOp
  },
  data() {
    return {
      orders: [],
      process_orders: [],
      no_init_orders: [],
      paused_orders: [],
      quality_orders: [],
      showPauseReportModal: false,
      show: 1,
      not_seem_1: 0,
      not_seem_2: 0,
      not_seem_3: 0,
      not_seem_4: 0,
    };
  },
  computed: {
      values() {
          //return this.showPauseReportModal;
      }
  },
  created() {
    this.getOrders();
    /*
    events.$on('operator-notify', data => {
      this.showPauseReportModal = true;
      console.log('Received...')
    });
    */
    setInterval(
      function () {
        location.reload();
      }.bind(this),
      60000
    );
    
  },
  methods: {
    refreshChanges() {
        location.reload();
    },
    pushItemOrder(order) {
      let item_add = order.productos.filter((item) => item.assigned == 1 && (item.status_flujo==1 || item.status_flujo=='1'))
      if (item_add && item_add.length > 0) {
        order.productos_filter = item_add;
        item_add.forEach((it) => {
          if (it.seem == null) {
            this.not_seem_1++;
          }
        });
        this.process_orders.push(order);
      }
      item_add = order.productos.filter((item) => item.assigned == 1 && (item.status_flujo==2 || item.status_flujo=='2'))
      if (item_add && item_add.length > 0) {
        order.productos_filter = item_add;
        item_add.forEach((it) => {
          if (it.seem == null) {
            this.not_seem_3++;
          }
        });
        this.paused_orders.push(order);
      }
      item_add = order.productos.filter((item) => item.assigned == 1 && (item.status_flujo==3 || item.status_flujo=='3'))
      if (item_add && item_add.length > 0) {
        order.productos_filter = item_add.producto;
        this.quality_orders.push(order);
      }
      item_add = order.productos.filter((item) => item.assigned == 1 && (item.status_flujo==0 || item.status_flujo=='0'))
      if (item_add && item_add.length > 0) {
        order.productos_filter = item_add;
        item_add.forEach((it) => {
          if (it.seem == null) {
            this.not_seem_2++;
          }
        });
        this.no_init_orders.push(order);
      }
    },
    setTab(el) {
      this.show = el;
    },
    getOrders() {      
      CrudService.getCRUD("orden", "otibyuser/"+this.opId).then((data) => {
        this.orders = data;
        data.forEach((item) => {
          this.pushItemOrder(item);
          let user_id = item.current_operator;
          if (item.status==2 && item.logs) {
            if (item.logs[item.logs.length - 1].status == 2 && item.logs[item.logs.length - 1].user_id != user_id) {
              this.showPauseReportModal = true;            
            }
          }
        });
        console.log('this.orders...')
        console.log(this.orders)
      });

    },
  },
};
</script>

<style scoped lang="css">
  .cards {
    width: 100%;
  }

  .card {
    cursor: pointer;
  }

  .card-active {
    background-color: #91C7D1;
  }

  .notifications {
    background-color: #EE2E2E;
    color: #fff;
    border-radius: 70px;
    max-width: 20px;
    text-align: center;
    position: relative;
  }
  
</style>
